import { render } from "./AdminActive.vue?vue&type=template&id=f2729f7e"
import script from "./AdminActive.vue?vue&type=script&lang=js"
export * from "./AdminActive.vue?vue&type=script&lang=js"
script.render = render

export default script